import React, { createContext, useContext, useState, useCallback } from 'react';

interface BankAccountsContextType {
  isOpen: boolean;
  mode: 'user' | 'store';
  entityId: string | null;
  open: (entityId: string, mode: 'user' | 'store') => void;
  close: () => void;
}

const BankAccountsContext = createContext<BankAccountsContextType | undefined>(undefined);

export const BankAccountsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [mode, setMode] = useState<'user' | 'store'>('user');
  const [entityId, setEntityId] = useState<string | null>(null);

  const open = useCallback((id: string, moduleMode: 'user' | 'store') => {
    setEntityId(id);
    setMode(moduleMode);
    setIsOpen(true);
  }, []);

  const close = useCallback(() => {
    setIsOpen(false);
  }, []);

  return (
    <BankAccountsContext.Provider value={{ isOpen, mode, entityId, open, close }}>
      {children}
    </BankAccountsContext.Provider>
  );
};

export const useBankAccounts = () => {
  const context = useContext(BankAccountsContext);
  if (context === undefined) {
    throw new Error('useBankAccounts must be used within BankAccountsProvider');
  }
  return context;
};
